import { render, staticRenderFns } from "./rosterspotTv.vue?vue&type=template&id=43276799&scoped=true"
import script from "./rosterspotTv.vue?vue&type=script&lang=js"
export * from "./rosterspotTv.vue?vue&type=script&lang=js"
import style0 from "./rosterspotTv.vue?vue&type=style&index=0&id=43276799&prod&lang=css"
import style1 from "./rosterspotTv.vue?vue&type=style&index=1&id=43276799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43276799",
  null
  
)

export default component.exports